import React from 'react';
import { Dropdown, Avatar } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  EditOutlined,
  SettingOutlined,
  ShopOutlined,
  QuestionCircleOutlined,
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons';
import NavItem from './NavItem';
import Flex from 'components/shared-components/Flex';
import { signOut } from 'store/slices/authSlice';
import styled from '@emotion/styled';
import {
  FONT_WEIGHT,
  MEDIA_QUERIES,
  SPACER,
  FONT_SIZES,
} from 'constants/ThemeConstant';
import { useNavigate } from 'react-router-dom';

const Icon = styled.div(() => ({
  fontSize: FONT_SIZES.LG,
}));

const Profile = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const UserInfo = styled('div')`
  padding-left: ${SPACER[2]};

  @media ${MEDIA_QUERIES.MOBILE} {
    display: none;
  }
`;

const Name = styled.div(() => ({
  fontWeight: FONT_WEIGHT.SEMIBOLD,
}));

const Title = styled.span(() => ({
  opacity: 0.8,
}));

const MenuItem = (props) => (
  <Flex as="a" href={props.path} alignItems="center" gap={SPACER[2]}>
    <Icon>{props.icon}</Icon>
    <span>{props.label}</span>
  </Flex>
);

const MenuItemSignOut = (props) => {
  const dispatch = useDispatch();
  const handleSignOut = () => {
    dispatch(signOut());
  };

  return (
    <div onClick={handleSignOut}>
      <Flex alignItems="center" gap={SPACER[2]}>
        <Icon>
          <LogoutOutlined />
        </Icon>
        <span>{props.label}</span>
      </Flex>
    </div>
  );
};

const MenuItemSettings = (props) => {
  const navigate = useNavigate();
  const handleSettings = () => {
    navigate('/settings/tour-assignment');
  };

  return (
    <div onClick={handleSettings}>
      <Flex alignItems="center" gap={SPACER[2]}>
        <Icon>
          <SettingOutlined />
        </Icon>
        <span>{props.label}</span>
      </Flex>
    </div>
  );
};

const MenuItemViewAccount = (props) => {
  const navigate = useNavigate();
  const handleViewAccount = () => {
    navigate('/settings/account');
  };

  return (
    <div onClick={handleViewAccount}>
      <Flex alignItems="center" gap={SPACER[2]}>
        <Icon>
          <UserOutlined />
        </Icon>
        <span>{props.label}</span>
      </Flex>
    </div>
  );
};

const items = [
  // {
  //   key: "Edit Profile",
  //   label: <MenuItem path="/" label="Edit Profile" icon={<EditOutlined />} />,
  // },
  // {
  //   key: "Account Setting",
  //   label: (
  //     <MenuItem path="/" label="Account Setting" icon={<SettingOutlined />} />
  //   ),
  // },
  // {
  //   key: "Account Billing",
  //   label: (
  //     <MenuItem path="/" label="Account Billing" icon={<ShopOutlined />} />
  //   ),
  // },
  // {
  //   key: "Help Center",
  //   label: (
  //     <MenuItem
  //       path="/"
  //       label="Help Center"
  //       icon={<QuestionCircleOutlined />}
  //     />
  //   ),
  // },
  {
    key: 'View account',
    label: <MenuItemViewAccount label="View account" />,
  },
  {
    key: 'Settings',
    label: <MenuItemSettings label="Settings" />,
  },
  {
    key: 'Sign out',
    label: <MenuItemSignOut label="Sign out" />,
  },
];

export const NavProfile = ({ mode }) => {
  const { user } = useSelector((state) => state.user);

  return (
    <Dropdown
      placement="bottomRight"
      menu={{ items }}
      trigger={['click']}
      dropdownRender={(menu) => (
        <div style={{ width: 'max-content', minWidth: 'auto' }}>{menu}</div>
      )}
    >
      <NavItem mode={mode}>
        <Profile>
          <Avatar src="/img/avatars/cartoon-dog.png" />
          <UserInfo className="profile-text">
            <Name>{user?.name ?? user?.email ?? 'Account'}</Name>
            <Title>{user?.email ? `Logged in as ${user.email}` : null}</Title>
          </UserInfo>
        </Profile>
      </NavItem>
    </Dropdown>
  );
};

export default NavProfile;
